import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
} from '@mui/material';

import './styles.scss';

// ─────────────────────────────────────────────────────────────────────────────
// Component
// ─────────────────────────────────────────────────────────────────────────────

const OldHomePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Box className="home-page">

      {/* ── Hero ─────────────────────────────────────────────── */}
      <Box className="nhp-hero">
        <Box className="nhp-hero__grid-bg" />
        <Container maxWidth="lg">
          <Box className="nhp-hero__content">
            <Typography className="nhp-hero__overline">
              Enterprise Zero-Hallucination Platform
            </Typography>
            <Typography variant="h1" className="nhp-hero__title">
              Eradicating friction between regulatory compliance and financial settlement in the
              physical economy.
            </Typography>
            <Typography className="nhp-hero__subtitle">
              LusidPay is the unified Regulatory Engineering platform empowering builders,
              agencies, and disadvantaged businesses to navigate strict federal compliance and
              secure project capital.
            </Typography>
            <Box className="nhp-hero__cta-row">
              <Button
                variant="contained"
                className="nhp-hero__btn nhp-hero__btn--light"
                onClick={() => navigate('/certify')}
              >
                Explore Lusid Certify
              </Button>
              <Button
                variant="outlined"
                className="nhp-hero__btn nhp-hero__btn--outline"
                onClick={() => navigate('/infrastructure')}
              >
                Explore LusidPay Infra
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* ── Products Section ─────────────────────────────────── */}
      <Box className="nhp-products">
        <Container maxWidth="lg">
          <Box className="nhp-products__header">
            <Typography variant="h2" className="nhp-products__title">
              First we prove compliance.{' '}
              <br />
              Then we unlock the capital.
            </Typography>
            <Typography className="nhp-products__subtitle">
              Trillion-dollar public infrastructure projects are bottlenecked by paper-heavy
              certifications and delayed supplier payments. We built the architecture to solve
              both sides of the equation.
            </Typography>
          </Box>

          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Box className="nhp-product-card nhp-product-card--certify">
                <Box className="nhp-product-card__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="16" y1="13" x2="8" y2="13" />
                    <line x1="16" y1="17" x2="8" y2="17" />
                    <polyline points="10 9 9 9 8 9" />
                  </svg>
                </Box>
                <Typography className="nhp-product-card__title">Lusid Certify</Typography>
                <Typography className="nhp-product-card__tag">The RegTech AI Engine (49 CFR)</Typography>
                <Typography className="nhp-product-card__body">
                  Lusid Certify is the AI-guided compliance engine that helps Disadvantaged Business 
                  Enterprises structure and document their own experiences into an organized, 
                  evidence-backed Personal Narrative – clearing the procurement backlog 
                  for State DOTs and Prime Contractors.
                </Typography>
                <Box
                  className="nhp-product-card__link"
                  component="span"
                  onClick={() => navigate('/certify')}
                >
                  Learn more &rarr;
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box className="nhp-product-card nhp-product-card--infra">
                <Box className="nhp-product-card__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="5" width="20" height="14" rx="2" />
                    <line x1="2" y1="10" x2="22" y2="10" />
                  </svg>
                </Box>
                <Typography className="nhp-product-card__title">LusidPay Infra</Typography>
                <Typography className="nhp-product-card__tag">The Domestic Financial Ledger</Typography>
                <Typography className="nhp-product-card__body">
                  An enterprise-grade settlement ledger built for the physical economy. Secure
                  project allocations, trigger digital lien waivers, and ensure frictionless
                  domestic disbursements so underrepresented suppliers get paid instantly.
                </Typography>
                <Box
                  className="nhp-product-card__link"
                  component="span"
                  onClick={() => navigate('/infrastructure')}
                >
                  Learn more &rarr;
                </Box>
              </Box>
            </Grid>
          </Grid>

        </Container>
      </Box>

    </Box>
  );
};

export default OldHomePage;
